import { Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import { EmphasisCatalog } from '../../modules/catalogs/catalog.types';
import CatalogCardBase from '../../modules/catalogs/pages/CatalogListPage/components/CatalogCard/CatalogCardBase';
import PATHS from '../../routes/routes.const';
import useTeceoStyles from '../../useTeceoStyles';
import { CAROUSEL_GRID_SIZES } from './GroupedCarousel';

type EmphasisCatalogCardGroupProps = {
  items: EmphasisCatalog[];
  enableLink: boolean;
};

const EmphasisCatalogCardGroup = ({ items, enableLink }: EmphasisCatalogCardGroupProps) => {
  const { classes: teceoClasses } = useTeceoStyles();
  return (
    <Grid container spacing={1.5}>
      {items.map((item, index) => {
        const catalogLink = item.catalog.isDefault
          ? PATHS.main.products.path
          : `/catalogs/${item.catalog.id}/products`;
        return (
          <Grid key={index} size={CAROUSEL_GRID_SIZES}>
            {enableLink ? (
              <Link to={catalogLink} className={teceoClasses.link}>
                <CatalogCardBase catalog={item.catalog} />
              </Link>
            ) : (
              <CatalogCardBase catalog={item.catalog} />
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default EmphasisCatalogCardGroup;
